<template>
  <div class="chat-window-wrapper">
    <ChatWindowMaximized
      v-if="isWindowMaximized"
      :class="[isWindowMaximized ? 'chatbox-open' : '']"
    ></ChatWindowMaximized>
    <ChatWindowMinimized></ChatWindowMinimized>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import ChatWindowMaximized from './chatWindowMaximized'

const ChatWindowMinimized = defineAsyncComponent(
  () =>
    import(
      /* webpackChunkName: "chat-window-minimized" */ './chatWindowMinimized'
    )
)

export default {
  components: { ChatWindowMaximized, ChatWindowMinimized },
  computed: {
    isWindowMaximized() {
      return this.$store.state.isWindowMaximized
    },
    isCalloutBubbleEnabled() {
      return (
        this.$store.state?.isCalloutBubbleEnabled &&
        !this.$store.getters.isKnowledgeAiEnabled
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css/theme.scss';
.chat-window-wrapper {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  bottom: 0;
  overflow: hidden;
  @include display-flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>
